import { bind } from '@react-rxjs/core'
import { createSignal } from '@react-rxjs/utils'
import { catchError, combineLatestWith, EMPTY, Observable, retry, switchMap, tap } from 'rxjs'
import { logAndCaptureException } from '../../monitoring'
import { registrationSuccess$ } from './success'
import { setRegistrationState } from '../state'

export interface LoginFactory {
  (props: { email: string; password: string }): Observable<void>
}

export const [loginFactory$, setLoginFactory] = createSignal<LoginFactory>()

export const [useLoginAfterRegistration] = bind(
  loginFactory$.pipe(
    combineLatestWith(registrationSuccess$),
    tap(() => {
      setRegistrationState({ name: 'login_loading' })
    }),
    switchMap(
      ([
        loginFactory,
        {
          input: { email, password },
        },
      ]) =>
        loginFactory({ email, password }).pipe(
          // try login up to 3 times
          retry({ count: 2, delay: 500 })
        )
    ),
    catchError((err) => {
      logAndCaptureException(err)
      setRegistrationState({ name: 'login_error' })
      return EMPTY
    })
  ),
  null
)
